import _ from "lodash";

import { IAction } from "redux/store/model";

import * as types from "./actionTypes";
import initialState from "./initialState";
import {
  IBulkCreateEventsSuccessAction,
  IBulkDeleteEventsSuccessAction,
  IBulkUpdateEventsSuccessAction,
  ICreateEventsSuccessAction,
  IDeleteEventsSuccessAction,
  IUpdateEventsSuccessAction,
  IUpdateSelectedFieldUserAction,
} from "./types";

export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case types.TRANSFER_EVENTS_BEGIN: {
      return {
        ...state,
        isTransferring: true,
      };
    }
    case types.TRANSFER_EVENTS_SUCCESS:
    case types.TRANSFER_EVENTS_FAILURE: {
      return {
        ...state,
        isTransferring: false,
      };
    }
    case types.CREATE_EVENTS_BEGIN:
    case types.BULK_CREATE_EVENTS_BEGIN: {
      return {
        ...state,
        isCreatingEvent: true,
      };
    }
    case types.CREATE_EVENTS_FAILURE:
    case types.BULK_CREATE_EVENTS_FAILURE: {
      return {
        ...state,
        isCreatingEvent: false,
      };
    }
    case types.CREATE_EVENTS_SUCCESS: {
      const events = (action as ICreateEventsSuccessAction).events;

      return {
        ...state,
        isCreatingEvent: false,
        events: _.uniqBy([...state.events, ...events], "id"),
      };
    }

    case types.FETCH_EVENTS_BEGIN: {
      return {
        ...state,
        isFetchingEvent: true,
        lastFetched: new Date(),
      };
    }
    case types.FETCH_EVENTS_FAILURE: {
      return {
        ...state,
        isFetchingEvent: false,
      };
    }
    case types.FETCH_EVENTS_SUCCESS: {
      const { events, append, count } =
        action as import("./types").IfetchEventsSuccessAction;

      return {
        ...state,
        isFetchingEvent: false,
        events: append ? _.uniqBy([...state.events, ...events], "id") : events,
        eventsCount: typeof count === "number" ? count : state.eventsCount,
      };
    }
    case types.UPDATE_EVENTS_BEGIN:
    case types.BULK_UPDATE_EVENTS_BEGIN: {
      return {
        ...state,
        isUpdatingEvent: true,
      };
    }
    case types.UPDATE_EVENTS_SUCCESS: {
      const { events: updatedEvents, deleted_ids } =
        action as IUpdateEventsSuccessAction;

      // First filter out deleted events
      const eventsWithoutDeleted = _.filter(state.events, (event) => {
        return !_.includes(deleted_ids || [], event.id);
      });

      // Then filter out events that will be updated and add the new ones
      const newEvents = _.concat(
        _.filter(eventsWithoutDeleted, (event) => {
          return !_.find(updatedEvents, { id: event.id });
        }),
        updatedEvents,
      );

      return {
        ...state,
        isUpdatingEvent: false,
        events: _.uniqBy(newEvents, "id"),
      };
    }
    case types.UPDATE_EVENTS_FAILURE:
    case types.BULK_UPDATE_EVENTS_FAILURE: {
      return {
        ...state,
        isUpdatingEvent: false,
      };
    }

    case types.DELETE_EVENTS_BEGIN:
    case types.BULK_DELETE_EVENTS_BEGIN: {
      return {
        ...state,
        isDeletingEvent: true,
      };
    }
    case types.DELETE_EVENTS_SUCCESS: {
      const { ids } = action as IDeleteEventsSuccessAction;
      return {
        ...state,
        isDeletingEvent: false,
        events: _.filter(state.events, (event) => {
          return !_.includes(ids, event.id);
        }),
      };
    }
    case types.DELETE_EVENTS_FAILURE:
    case types.BULK_DELETE_EVENTS_FAILURE: {
      return {
        ...state,
        isDeletingEvent: false,
      };
    }
    case types.UPDATE_SELECTED_FIELD_USER: {
      return {
        ...state,
        selectedFieldUsers: (action as IUpdateSelectedFieldUserAction)
          .selectedFieldUsers,
      };
    }

    case types.CLEAR_EVENTS: {
      return {
        ...state,
        events: [],
      };
    }

    case types.BULK_CREATE_EVENTS_SUCCESS: {
      const { events } = action as IBulkCreateEventsSuccessAction;

      return {
        ...state,
        isCreatingEvent: false,
        events: _.uniqBy([...state.events, ...events], "id"),
      };
    }

    case types.BULK_UPDATE_EVENTS_SUCCESS: {
      const { events: updatedEvents, deleted_ids } =
        action as IBulkUpdateEventsSuccessAction;
      action as IBulkUpdateEventsSuccessAction;
      const newEvents = _.concat(
        _.filter(state.events, (event) => {
          return !_.find(updatedEvents, { id: event.id });
        }),
        updatedEvents,
      );
      return {
        ...state,
        isUpdatingEvent: false,
        events: _.filter(_.uniqBy(newEvents, "id"), (event) => {
          return !_.includes(deleted_ids || [], event.id);
        }),
      };
    }

    case types.BULK_DELETE_EVENTS_SUCCESS: {
      const { ids, events } = action as IBulkDeleteEventsSuccessAction;

      let updatedEvents = state.events;

      if (events) {
        // If events are provided in response, replace/add them to the store
        updatedEvents = _.uniqBy([...state.events, ...events], "id");
      }

      return {
        ...state,
        isDeletingEvent: false,
        events: _.filter(updatedEvents, (event) => {
          return !_.includes(ids, event.id);
        }),
      };
    }

    default:
      return state;
  }
}
